import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';

export default class DocumentTypeApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getTableColumns(doc_type: string): Promise<any> {
    const data = { doc_type: doc_type };
    const querystring = this.encodeQueryData(data);
    return super.get(
      api.get_document_tables_with_columns + '?' + querystring,
      {},
    );
  }

  public async getTable(doc_type: string): Promise<any> {
    const data = { doc_type: doc_type };
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_document_tables + '?' + querystring, {});
  }

  public async getAllDocumentTables(): Promise<any> {
    return super.get(api.get_all_document_tables);
  }

  public async getDocumentTableColumns(table_name: string): Promise<any> {
    const data = { table_name: table_name };
    const querystring = this.encodeQueryData(data);
    // logInfo(api.get_document_table_columns + '?' + querystring,{})
    return super.get(api.get_document_table_columns + '?' + querystring, {});
  }

  public async getAllDocumentTableColumns(): Promise<any> {
    return super.get(api.get_all_document_table_columns, {});
  }

  public async createTable(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }

    return super.post(api.create_document_table, formData);
  }

  public async fetchDocTypes(): Promise<any> {
    return super.get(api.get_document_types);
  }

  public async fetchDocTypesSubTypes(): Promise<any> {
    return super.get(api.get_document_types_and_sub_types);
  }

  public async fetchTypeFilters(): Promise<any> {
    return super.post(api.get_document_type_filter_keys, new FormData());
  }

  public async updateTableCustomColumn(
    id: string,
    formData: FormData,
  ): Promise<any> {
    return super.post(api.update_document_table_column + '?id=' + id, formData);
  }

  // ===============================================Versioning Apis=====================================================================================


  public async approveDocumentTypeAttributeValue(valueId: string): Promise<any> {
    const versionValuesApi = api.approve_document_type_attribute_value.replace('{value_id}', valueId);
    return super.patch(versionValuesApi, {});
  }

  public async toggleActiveDocumentTypeAttributeValue(valueId: string, isActive: boolean): Promise<any> {
    const versionValuesApi = api.document_type_attribute_value_toggle_active.replace('{value_id}', valueId);
    const querystring = this.encodeQueryData({ is_active: isActive });
    return super.patch(versionValuesApi + '?' + querystring, {});
  }

  public async updateDocumentTypeAttributeValue(valueId: string, data: any): Promise<any> {
    const versionValuesApi = api.update_document_type_attribute_value.replace('{value_id}', valueId);
    const querystring = this.encodeQueryData({ ignore_validation: false });
    return super.patch(versionValuesApi + '?' + querystring, { value: data.value });
  }

  public async getAllPurchaseOrderRulesRevisions(params: any): Promise<any> {
    const querystring = this.encodeQueryData({ doc_type_key: params.doc_type_key });
    return super.post(api.get_all_purchase_order_rules_revisions + '?' + querystring, {});
  }

  public async clonePurchaseOrderRulesAsDraft(params: any): Promise<any> {
    const querystring = this.encodeQueryData({ value_id: params.value_id });
    const apiUrl = api.clone_purchase_order_rules_as_draft.replace('{org_id}', params.org_id);
    return super.post(apiUrl + '?' + querystring, {});
  }

  public async deletePurchaseOrderRule(valueId: string): Promise<any> {
    const deleteApi = api.delete_purchase_order_rule.replace('{value_id}', valueId);
    return super.delete(deleteApi, {});
  }

  public async resetPurchaseOrderRulesToDefault(docTypeKey: string): Promise<any> {
    const querystring = this.encodeQueryData({ doc_type_key: docTypeKey });
    return super.post(api.reset_purchase_order_rules_to_default + '?' + querystring, {});
  }

  public async getActivePurchaseOrderRulesRevision(docTypeKey: string): Promise<any> {
    const querystring = this.encodeQueryData({ doc_type_key: docTypeKey });
    return super.post(api.get_active_purchase_order_rules_revision + '?' + querystring, {});
  }

}
